import {Injectable} from '@angular/core';
import {
    MxReferencedEntityService
} from "../../../../../mx-core/src/lib/modules/mx-grid/services/mx-referenced-entity.service";

@Injectable({
    providedIn: 'root'
})
export class PrlReferencedEntityService implements MxReferencedEntityService {
    getReferencedEntityFilter(entityName: string): string {
        return "";
    }

    getReferencedEntityMapping(entityName: string, row: any): string {
        return "";
    }

    getReferencedReportMapping(referencedReport: string): string {
        return "";
    }

    hasAccess(entityName: string): boolean {
        return false;
    }


}
